exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-treeselect__control{font-size:.875rem!important}.credits-table{height:75vh;font-size:9pt}.credits-table .credits-table-style-actions{min-width:120px}.credits-table .credits-table-style-actions .actions-icons{text-align:center;white-space:nowrap}.credits-table .credits-table-style-th-datetime{min-width:110px}.credits-table .credits-table-style-td-datetime{text-align:center}", ""]);

// exports
